import React, { useEffect, useState, useRef } from "react";
// import barcode from "./barcode.png";
import logo from "../../../images/logo-transparent.7a4badaf.png";
import { connect } from "react-redux";
import { savePDF } from "@progress/kendo-react-pdf";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { getLedgerDetails } from "../../actions/GenomicsAdminAction";
import ReactToPrint from "react-to-print";
interface PropsIB {
  getLedgerDetails: any;
  clientLedgerDetails: any;
}

const InvoiceBreakup: React.FC<PropsIB> = ({
  clientLedgerDetails,
  getLedgerDetails,
}) => {
  const history = useHistory();
  const [data, setData] = useState<any>(
    JSON.parse(localStorage.InvoiceBreakup)
  );
  useEffect(() => {
    if (data.invoice_no !== undefined) {
      getLedgerDetails(`invoice_no=${data.invoice_no}`);
    }
  }, [data]);

  const contentArea = useRef<any>(0);

  const handleExportWithFunction = () => {
    savePDF(contentArea.current, {
      scale: 0.5,
      paperSize: "A4",
      fileName: `INVOICE-${data.invoice_no}`,
    });
  };
  const handleBack = () => {
    localStorage.removeItem("InvoiceBreakup");
    history.push(`/dashboard/gnadmin/cc_invoice`);
  };
  const componentRef = useRef<any>(null);
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);
  const reactToPrintTrigger = React.useCallback(() => {
    return <button>Print Receipt</button>;
  }, []);
  // useEffect(() => {
  //   var val: number = 0;
  //   clientLedgerDetails.results &&
  //     clientLedgerDetails.results.length > 0 &&
  //     clientLedgerDetails.results.map((qual: any, index: any) => {
  //       val = val + Number(qual.amount);
  //     });

  //   console.log(val, "ghjk");
  // }, [clientLedgerDetails]);

  return (
    <div
      style={{
        margin: "50px auto",
      }}
    >
      <button
        style={{
          width: "120px",
          borderRadius: "5%",
          backgroundColor: "#ef5350",
          color: "white",
        }}
        onClick={handleBack}
      >
        {"<< Go Back"}
      </button>
      <ReactToPrint
        content={reactToPrintContent}
        trigger={reactToPrintTrigger}
      />
      {/* <button
        style={{
          width: "200px",
          borderRadius: "5%",
          backgroundColor: "#4caf50",
          color: "white",
        }}
        onClick={handleExportWithFunction}
      >
        Print Receipt
      </button> */}
      <div
        style={{
          width: "1000px",
          border: "1px solid grey",
          margin: 20,
        }}
      >
        {/* <div
          ref={contentArea}
          style={{
            margin: 20,
          }}
        > */}
        <div
          ref={componentRef}
          style={{
            margin: 20,
          }}
        >
          {/* //header */}

          <div style={{ width: "100%" }}>
            <div style={{ width: "100%", display: "flex" }}>
              <div style={{ width: "50%" }}>
                <table style={{ width: "100%", fontSize: 15 }}>
                  <tr>
                    <th style={{ width: "40%", verticalAlign: "top" }}>
                      Centre Name :
                    </th>
                    <th>{data.centre_name}</th>
                  </tr>

                  <tr>
                    <th style={{ width: "40%", verticalAlign: "top" }}>
                      Invoice No. :
                    </th>
                    <th>{data.invoice_no}</th>
                  </tr>
                  <tr>
                    <th style={{ width: "40%", verticalAlign: "top" }}>
                      Invoice Created At :
                    </th>
                    <th>
                      {moment(data.bill_date).format("DD-MM-YYYY, h:mm A")}
                    </th>
                  </tr>
                  <tr>
                    <th style={{ width: "40%", verticalAlign: "top" }}>
                      Billing From :
                    </th>
                    <th>
                      {moment(data.start_date).format("DD-MM-YYYY, h:mm A")}
                    </th>
                  </tr>
                  <tr>
                    <th style={{ width: "40%", verticalAlign: "top" }}>
                      Billing To :
                    </th>
                    <th>
                      {moment(data.end_date).format("DD-MM-YYYY, h:mm A")}
                    </th>
                  </tr>
                  <tr>
                    <th style={{ width: "40%", verticalAlign: "top" }}>
                      Total Billing Done :
                    </th>
                    <th>{data.total_billed_amount}/-</th>
                  </tr>
                  <tr>
                    <th style={{ width: "40%", verticalAlign: "top" }}>
                      Total RCL Share Amt. :
                    </th>
                    <th>{data.rcl_share_amt}/-</th>
                  </tr>
                </table>
              </div>
              <div style={{ width: "50%", textAlign: "end" }}>
                <img src={logo} width="250px" />
              </div>
            </div>

            <hr />
          </div>

          {/* //test table */}
          <table style={{ width: "100%" }}>
            <tr>
              <th style={{ border: "1px solid #dfdfdf" }}>Sr. No.</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Bill No.</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Patient Name</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Age</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Gender</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Test Code</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Test Name</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Is Coupon</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Gross</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Discount %</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Client Share</th>

              <th style={{ border: "1px solid #dfdfdf" }}>Credit/Debit</th>
              <th style={{ border: "1px solid #dfdfdf" }}>RCL Share</th>
              <th style={{ border: "1px solid #dfdfdf" }}>Balance</th>

              <th style={{ border: "1px solid #dfdfdf" }}>Payment Date</th>
            </tr>

            {clientLedgerDetails.results &&
              clientLedgerDetails.results.length > 0 &&
              clientLedgerDetails.results.map((qual: any, index: any) => {
                return (
                  <tr>
                    <th style={{ border: "1px solid #dfdfdf" }}>{index + 1}</th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.booking}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.customer_name}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.customer_age}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.customer_gender}
                    </th>

                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.package_code}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.package_name}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.camp_coupon}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.amount}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.client_discount_percentage}%
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {Number(qual?.client_share).toFixed(2)}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {qual?.ledger_type}
                    </th>

                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {Number(qual?.rcl_share).toFixed(2)}
                    </th>

                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {Number(qual?.center_rem_balance).toFixed(2)}
                    </th>
                    <th style={{ border: "1px solid #dfdfdf" }}>
                      {moment(qual?.created_at).format(
                        "DD-MM-YYYY, hh:mm:ss A"
                      )}
                    </th>
                  </tr>
                );
              })}
          </table>

          <hr />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: any) => ({
  clientLedgerDetails: state.GenomicsAdminReducer.clientLedgerDetails,
});

export default connect(mapStateToProps, {
  getLedgerDetails,
})(InvoiceBreakup);
